var checkBtn = {
  init: init,
  checkNormalLogin: checkNormalLogin,
  checkReg: checkReg,
  checkFastLogin: checkFastLogin
}

function checkNormalLogin () {
  var canLogin
  if (this.$verifyCode.parent().hasClass('hide')) {
    canLogin = this.$LoginMobile.val() && this.$LoginPassword.val()
  } else {
    canLogin = this.$LoginMobile.val() && this.$LoginPassword.val() && this.$verifyCode.val()
  }
  refreshBtn(canLogin, this.$LoginBtn)
}

function checkReg () {
  var canLogin = this.$RegMobile.val() && this.$RegPassword.val() && this.$RegVerifyCode.val()
  refreshBtn(canLogin, this.$RegBtn)
}

function checkFastLogin () {
  var canLogin = this.$FastMobile.val() && this.$FastVerifyCode.val()
  if (this.$FastMobile.val().length == 13) {
    this.$btnGetCode.removeClass('unavailable')
  } else {
    this.$btnGetCode.addClass('unavailable')
  }
  refreshBtn(canLogin, this.$FastBtn)
}

function refreshBtn (canLogin, btn) {
  if (canLogin) {
    btn.removeClass('unavailable')
  } else {
    btn.addClass('unavailable')
  }
}

function init ($container) {
  var $formLogin = $container.find('.form-login')
  var $formReg = $container.find('.form-reg')
  var $formFast = $container.find('.fast-login')
  this.$LoginMobile = $formLogin.find('.input-mobile')
  this.$LoginPassword = $formLogin.find('.input-password')
  this.$verifyCode = $formLogin.find('.input-verify-code')
  this.$LoginBtn = $formLogin.find('.btn-submit')
  this.$RegBtn = $formReg.find('.btn-submit')
  this.$FastBtn = $formFast.find('.btn-submit')
  this.$RegMobile = $formReg.find('.input-mobile')
  this.$RegPassword = $formReg.find('.input-password')
  this.$RegVerifyCode = $formReg.find('.input-getcode')
  this.$FastMobile = $formFast.find('.input-mobile')
  this.$FastVerifyCode = $formFast.find('.input-getcode')
  this.$btnGetCode = $container.find('.btn-getcode')

  const EVENTS = 'keyup change paste'
  this.$LoginMobile
    .add(this.$verifyCode)
    .on(EVENTS, () => {
      setTimeout(() => {
        this.checkNormalLogin()
      }, 200)
    })
  this.$LoginMobile
    .add(this.$LoginPassword)
    .on(EVENTS, () => {
      setTimeout(() => {
        this.checkNormalLogin()
      }, 200)
    })
  this.$RegMobile
    .add(this.$RegPassword)
    .add(this.$RegVerifyCode)
    .on(EVENTS, () => {
      setTimeout(() => {
        this.checkReg()
      }, 200)
    })
  this.$FastMobile
    .add(this.$FastVerifyCode)
    .on(EVENTS, () => {
      setTimeout(() => {
        this.checkFastLogin()
      }, 200)
    })
}

export default checkBtn



// WEBPACK FOOTER //
// ./src/user/widget/checkLoginButton.js